export default {
  title: 'Waarom deze afbeelding opnieuw genereren?',
  description: 'Help ons de AI te verbeteren door te vertellen wat er niet klopte.',
  reasons: {
    wrong_style: 'Verkeerde stijl',
    wrong_colors: 'Verkeerde kleuren',
    wrong_food_item: 'Verkeerd gerecht',
    low_quality: 'Lage kwaliteit',
    doesnt_match_brand: 'Past niet bij mijn merk',
    text_issues: 'Tekst of labels kloppen niet',
    other: 'Anders',
  },
  details_label: 'Nog iets? (optioneel)',
  details_placeholder: 'Voeg meer details toe zodat we het beter begrijpen…',
  cancel: 'Annuleren',
  confirm: 'Opnieuw genereren',
};
